export default __webpack_public_path__ + "static/media/btn-lpmall-view-cart.57edafaf.svg";